export default[
	{
		path: '/',
		name: 'Login',
		component: () => import('@/Modules/Login/Views/Login.vue'),
		meta : {
			title : 'Login'
		}
	},
	{
		path: '/logout',
		name: 'Logout',
		component: () => import('@/Modules/Login/Views/Logout.vue'),
		meta : {
			title : 'Logout'
		}
	},
	{
		path: '/dashboard',
		name: 'DashBoard',
		component: () => import('@/Modules/Login/Views/DashBoard.vue'),
		meta : {
			title : 'Dashboard'
		}
	},
	{
		path: '/profile',
		name: 'Profile',
		component: () => import('@/Modules/Login/Views/Profile.vue'),
		meta : {
			title : 'My Profile'
		}
	},
	
	{
		path: '/forgot-password',
		name: 'ForgotPassword',
		component: () => import('@/Modules/Login/Views/ForgotPassword.vue'),
		meta : {
			title : 'Forgot Password'
		}
	},
	
	{
		path: '/forgot-password/update',
		name: 'ForgotPasswordUpdate',
		component: () => import('@/Modules/Login/Views/ForgotPasswordUpdate.vue'),
		meta : {
			title : 'Forgot Password Update'
		}
	},
	
	
	
]
